<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title style="min-width: 150px">Problemos</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-flex xs6 md2>
        <v-text-field
          append-icon="search"
          single-line
          hide-details
          clearable
          v-model="filter"
          :label="$t('orders_crud.filter')"
          autofocus
          @input="isChangingFilter = true"
        ></v-text-field>
      </v-flex>

      <v-flex xs6 md2>
        <v-text-field
          prepend-icon="event"
          single-line
          readonly
          hide-details
          clearable
          v-model="createdFrom"
          :label="'Įvesta nuo'"
          @click="changeDate($event, 'createdFrom')"
        ></v-text-field>
      </v-flex>

      <v-flex xs6 md2>
        <v-text-field
          prepend-icon="event"
          single-line
          readonly
          hide-details
          clearable
          v-model="createdTo"
          :label="'Įvesta iki'"
          @click="changeDate($event, 'createdTo')"
        ></v-text-field>
      </v-flex>

      <v-flex xs6 md2>
        <v-text-field
          prepend-icon="event"
          single-line
          readonly
          hide-details
          clearable
          v-model="solvedFrom"
          :label="'Išspręsta nuo'"
          @click="changeDate($event, 'solvedFrom')"
        ></v-text-field>
      </v-flex>

      <v-flex xs6 md2>
        <v-text-field
          prepend-icon="event"
          single-line
          readonly
          hide-details
          clearable
          v-model="solvedTo"
          :label="'Išspręsta iki'"
          @click="changeDate($event, 'solvedTo')"
        ></v-text-field>
      </v-flex>

      <v-flex xs24 md8>
        <!-- status selector -->
        <status-selector
          :from="statusFrom"
          :to="statusTo"
          :table="'problems'"
          :language="this.$router.currentRoute.params.lang.toUpperCase()"
          @statusesChanged="changeStatusFilters"
        />
      </v-flex>

      <v-btn color="primary" @click="openNewProblemDialog">{{
        $t("problems_table.new_problem")
      }}</v-btn>
    </v-toolbar>

    <div class="table-wrapper">
      <div class="progress-wrapper">
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
      </div>
      <div class="rTable">
        <div class="rTableRow problem-header">
          <div
            class="rTableHead"
            v-for="(header, i) in headers"
            :key="i"
            :style="{ width: header.width + '%' }"
          >
            {{ header.text }}
          </div>
        </div>
        <div class="rTableRow" v-for="(problem, i) in problems" :key="i">
          <div class="rTableCell">{{ problem.subject }}</div>
          <div class="rTableCell">{{ problem.order_code }}</div>
          <div class="rTableCell">
            <v-icon
              v-for="(attachment, i) in problem.attachments"
              :key="i"
              v-tooltip="attachment.file_name"
              @click="downloadAttachment(attachment)"
              >attachment</v-icon
            >
          </div>
          <div class="rTableCell">{{ problem.comment }}</div>
          <div class="rTableCell">{{ problem.user_name }}</div>
          <div class="rTableCell">{{ problem.created_at }}</div>
          <div class="rTableCell">{{ getStatusName(problem.status) }}</div>
          <div class="rTableCell">{{ problem.solved_at }}</div>
          <div class="rTableCell number-cell">
            {{ getTimeSpent(problem.time_spent) }}
          </div>
          <div class="rTableCell text-cell">
            <v-icon
              v-tooltip="$t('problems_table.edit')"
              small
              @click="openEditProblemDialog(problem)"
              >edit</v-icon
            >
            <v-icon
              v-if="user['type'] == 0"
              v-tooltip="$t('problems_table.delete')"
              small
              @click="deleteProblem(problem)"
              >delete</v-icon
            >
          </div>
        </div>
        <div class="rTableRow">
          <div class="rTableCellHidden" v-for="i in 8" :key="i"></div>
          <div class="rTableCell number-cell">{{ timeSpent }}</div>
          <div class="rTableCellHidden"></div>
        </div>
      </div>
    </div>

    <div class="text-xs-center">
      <v-pagination
        v-model="pagination.page"
        :length="pagination.pages"
        @input="initialize"
      ></v-pagination>
    </div>
    <ProblemDialog ref="problemDialog" @updated="initialize" />
    <DatePicker ref="datePicker" @dateSelected="selectDate" />
  </div>
</template>

<script>
import Problem from "@/models/Problem.js";
import Helper from "@/models/Helper.js";
import User from "@/models/User.js";
import ProblemDialog from "@/components/production-planning/ProblemDialog.vue";
import StatusSelector from "@/components/status-changes/StatusSelector.vue";
import DatePicker from "@/components/DatePicker.vue";
export default {
  components: {
    ProblemDialog,
    StatusSelector,
    DatePicker,
  },
  data() {
    return {
      loading: false,
      filter: "",
      filterTimer: 0,
      isChangingFilter: false,
      dialog: false,
      createdFrom: null,
      createdTo: null,
      solvedFrom: null,
      solvedTo: null,
      statusFrom: 0,
      statusTo: 3,
      user: new User(this.$session.get("user")),
      headers: [
        { text: "Antraštė", sortable: false, value: "subject", width: 20 },
        { text: "Užsakymas", value: "order", sortable: false, width: 5 },
        { text: "Priedai", value: "attachments", sortable: false, width: 5 },
        { text: "Komentaras", value: "comment", sortable: false, width: 20 },
        { text: "Įvedė", value: "user_name", sortable: false, width: 10 },
        { text: "Įvesta", value: "created_at", sortable: false, width: 8 },
        { text: "Statusas", value: "status", sortable: false, width: 8 },
        { text: "Išspręsta", value: "solved_at", sortable: false, width: 5 },
        {
          text: "Sugaišta laiko, h",
          value: "time_spent",
          sortable: false,
          width: 7,
        },
        { text: "Veiksmai", value: "actions", sortable: false, width: 5 },
      ],
      problems: [],
      problemStatuses: [],
      pagination: {
        perPage: 50,
        page: 1,
        pages: 1,
      },
      statusNames: this.$session.get("statusNames").filter((e) => {
        return e.table_name == "problems";
      }),
    };
  },

  created() {
    this.initialize();
  },

  watch: {
    isChangingFilter(val) {
      if (!val) {
        this.search();
      }
    },

    filter() {
      clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(() => {
        this.isChangingFilter = false;
      }, 500);
    },

    createdFrom() {
      this.search();
    },
    createdTo() {
      this.search();
    },
    solvedFrom() {
      this.search();
    },
    solvedTo() {
      this.search();
    },
    statusFrom() {
      this.search();
    },
    statusTo() {
      this.search();
    },
  },

  computed: {
    timeSpent() {
      if (this.problems.length == 0) return 0;
      let totalTime = 0;
      for (let problem of this.problems) {
        if (problem.time_spent) {
          totalTime += problem.time_spent;
        }
      }
      return totalTime.toFixed(1);
    },
  },

  methods: {
    search() {
      this.pagination.page = 1;
      this.initialize();
    },

    async initialize() {
      this.loading = true;
      // eslint-disable-next-line
      const { problems, pages, page, perPage } = await Problem.loadProblems({
        params: {
          filter: this.filter,
          page: this.pagination.page,
          per_page: this.pagination.perPage,
          created_from: this.createdFrom,
          created_to: this.createdTo,
          solved_from: this.solvedFrom,
          solved_to: this.solvedTo,
          status_from: this.statusFrom,
          status_to: this.statusTo,
        },
      });
      this.pagination.pages = pages;
      this.problems = problems;
      this.loading = false;
    },

    downloadAttachment(attachment) {
      window.open(attachment.location, "_blank");
    },

    getLocale() {
      return Helper.getLocale(this);
    },

    openNewProblemDialog() {
      this.$refs.problemDialog.openCreate();
    },
    openEditProblemDialog(problem) {
      this.$refs.problemDialog.openEdit(problem);
    },
    /**
     * changes status filters
     */
    changeStatusFilters(statuses) {
      this.statusFrom = statuses.status_from != null ? statuses.status_from : 0;
      this.statusTo = statuses.status_to != null ? statuses.status_to : 100;
    },
    async deleteProblem(problem) {
      const confirmed = confirm(this.$t("problems_table.confirm_delete"));
      if (!confirmed) return;
      await problem.remove();
      this.initialize();
    },

    getStatusName(statusValue) {
      const foundStatus = this.statusNames.find((statusObj) => {
        return statusObj.status === statusValue;
      });
      if (!foundStatus) return 0;
      return foundStatus.text;
    },

    getTimeSpent(timeSpent) {
      if (!timeSpent) return;
      return timeSpent.toFixed(1);
    },

    changeDate(event, key) {
      if (this.$refs.datePicker) {
        this.$refs.datePicker.open(event, key);
      }
    },

    selectDate(date, key) {
      this[key] = date;
    },
  },
};
</script>

<style>
.rTable {
  display: table;
  width: 100%;
}
.rTableRow {
  display: table-row;
}
.rTableRow:hover:not(.problem-header) {
  background: rgba(216, 206, 208, 0.24);
}
.rTableHeading {
  display: table-header-group;
  background-color: #ddd;
}
.rTableCell,
.rTableHead {
  display: table-cell;
  padding: 3px 10px;
  border: 1px solid #99999911;
  font-size: 13px;
}
.rTableHead {
  color: rgba(0, 0, 0, 0.54);
  font-weight: bold;
  background: rgba(216, 206, 208, 0.26);
  height: 50px;
}
.rTableCellHidden {
  display: table-cell;
  padding: 3px 10px;
  border: none;
}
.rTableHeading {
  display: table-header-group;
  background-color: #ddd;
  font-weight: bold;
}
.rTableFoot {
  display: table-footer-group;
  font-weight: bold;
  background-color: #ddd;
}
.rTableBody {
  display: table-row-group;
}
.number-cell {
  text-align: right;
}
.text-cell {
  text-align: center;
}
.table-wrapper {
  width: 98%;
}
.progress-wrapper {
  height: 7px;
}
</style>